<template>
  <div id='homepage'>
    Welcome to the Chaverim homepage!
  </div>
</template>

<script>
export default {
  name: 'Homepage'
}
</script>

<style scoped>

#homepage {
  background-color: 'orange'
}

</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue